/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderCmRoutingModule } from './builder-cm-routing.module';
import { CmListBusinessService } from './resources/cm-list-business.service';
import { CmJobDetailsBusinessService } from './resources/cm-job-details-business.service';
import { CmListComponent } from './components/cm-list/cm-list.component';
import { CMJobRestService } from './resources/cm-job-rest.service';
import { CmJobDetailsTabContainerComponent } from './components/cm-job-details/cm-job-details-tab-container.component';
import { JobDetailsBillingTabComponent } from './components/cm-job-details/job-details-billing-tab/job-details-billing-tab.component';
import { CmWorksheetComponent } from './components/cm-worksheet/cm-worksheet.component';
import { JobBillingWorksheetBusinessService } from './resources/cm-worksheet-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),

    BuilderCmRoutingModule,
  ],
  providers: [
    CmListBusinessService,
    CmJobDetailsBusinessService,
    CMJobRestService,
    JobBillingWorksheetBusinessService,
  ],
  declarations: [
    CmListComponent,
    CmWorksheetComponent,
    CmJobDetailsTabContainerComponent,
    JobDetailsBillingTabComponent,
  ],
  entryComponents: [
    JobDetailsBillingTabComponent,
  ],
  schemas: [ NO_ERRORS_SCHEMA ],
})

export class BuilderCmModule {
}
